var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssetFinance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 28H2V30H30V28Z",
    fill: "#FEA82A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 11.0001C27.2652 11.0001 27.5196 10.8947 27.7071 10.7072C27.8946 10.5196 28 10.2653 28 10.0001V7.00006C27.9999 6.79455 27.9365 6.59405 27.8184 6.42586C27.7003 6.25766 27.5333 6.12994 27.34 6.06006L16.34 2.06006C16.1203 1.98063 15.8797 1.98063 15.66 2.06006L4.66 6.06006C4.46673 6.12994 4.29968 6.25766 4.18159 6.42586C4.06349 6.59405 4.00009 6.79455 4 7.00006V10.0001C4 10.2653 4.10536 10.5196 4.29289 10.7072C4.48043 10.8947 4.73478 11.0001 5 11.0001H6V24.0001H4V26.0001H28V24.0001H26V11.0001H27ZM6 7.70006L16 4.06006L26 7.70006V9.00006H6V7.70006ZM18 24.0001H14V11.0001H18V24.0001ZM8 11.0001H12V24.0001H8V11.0001ZM24 24.0001H20V11.0001H24V24.0001Z",
    fill: "#1393EA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetFinance);
export default __webpack_public_path__ + "static/media/asset-finance.40bdf3b8.svg";
export { ForwardRef as ReactComponent };